import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { ButtonBase } from '@fenderdigital/ui/Button';
import { Focus } from '@fenderdigital/ui/utils/css';

export const FreemiumAdOverlay = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100%;
  left: 0;
  top: 0;
`;

export const FreemiumAdContainer = styled.div`
  display: grid;
  place-items: center;
  height: auto;
  opacity: 1;
  background-color: white;
  z-index: 1;
  border-radius: 8px;
  overflow: hidden;
  ${up('laptop')} {
    grid-auto-flow: column;
  }
`;

export const AdImageWire = styled.img`
  width: 293px;
  border: none;
`;

export const AdCopyContainer = styled.div`
  padding: 24px 16px;

  ${up('laptop')} {
    padding: 24px 32px;
  }
`;

export const HeadingLine = styled.span`
  display: block;
  width: 100%;
  text-align: center;
`;

export const TimeLeftSpan = styled(HeadingLine)`
  font-size: ${({ theme: { fontSizes } }): string => fontSizes.f10};
`;

export const IgnoreButton = styled(ButtonBase)`
  font-family: ${({ theme: { fonts } }): string => fonts.sourceSans};
  font-size: ${({ theme: { fontSizes } }): string => fontSizes.f2};
  text-decoration: underline;
  text-transform: none;
`;

export const Disclaimer = styled(HeadingLine)`
  font-size: ${({ theme: { fontSizes } }): string => fontSizes.f1};
`;

export const FreemiumBundleAdContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme: { colors } }): string => colors.white};
  z-index: 1;
  border-radius: 8px;
  overflow: hidden;
`;

export const BundleAdImageContainer = styled.div`
  position: relative;
`;

export const BundleAdImage = styled.img`
  width: 288px;
  height: 323px;

  ${up('laptop')} {
    width: 553px;
  }
`;

export const BundleImageTextContainer = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;

  > h1 {
    max-width: 80%;
  }

  > p {
    max-width: 50%;
  }

  ${up('laptop')} {
    top: 58px;
    left: 32px;
    max-width: 60%;

    > h1 {
      max-width: 100%;
    }

    > p {
      max-width: 100%;
    }
  }
`;

export const SkewedBanner = styled.div<{ skewDirection: 'up' | 'down' }>`
  display: inline-block;
  background-color: ${({ theme: { colors } }): string => colors.black};
  transform: ${({ skewDirection }): string =>
    skewDirection === 'up' ? 'rotate(-4deg)' : 'rotate(4deg)'};
  text-align: center;
  padding: 2px 40px;
`;

export const BundleBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;

  > a {
    align-self: center;
    padding: 0.5rem 1.5rem;
    max-width: 80%;

    ${up('laptop')} {
      max-width: 43%;
    }
  }
`;

export const BundleSecondBannerContainer = styled.div`
  position: absolute;
  top: -20px;
`;

export const BundleSecondaryButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  width: 80%;

  ${up('laptop')} {
    width: 50%;
  }

  button {
    font-size: ${({ theme: { fontSizes } }): string => fontSizes.f1};
    font-family: ${({ theme: { fonts } }): string => fonts.futuraDemi};
    text-transform: none;
    border-right: 1px solid ${({ theme: { colors } }): string => colors.moonGray};
    padding: 0;
    margin-right: 3px;
    min-width: 30%;
  }
`;

export const BundleExternalLink = styled.a`
  ${Focus};
  font-size: ${({ theme: { fontSizes } }): string => fontSizes.f1};
  font-family: ${({ theme: { fonts } }): string => fonts.futuraDemi};
  color: ${({ theme: { colors } }): string => colors.black};
  margin-left: 5px;

  ${up('laptop')} {
    margin-left: 0;
    min-width: 60%;
    text-align: center;
  }

  svg {
    position: absolute;
    transform: rotate(-90deg);
    height: 1.5rem;
    bottom: -6px;
    right: -10px;

    ${up('laptop')} {
      right: 5px;
    }
  }
`;
